export enum AdminDocDivision {
  CCL = 'ccl',
  TSF = 'tsf',
  Company = 'company',
  OnboardingCCL = 'onboarding-ccl',
  OnboardingTSF = 'onboarding-tsf',
}

export enum AdminDocStatus {
  Open = 'open',
  Done = 'done',
}

export const ADMIN_DOC_DEPARTMENTS = [
  'Admin',
  'Analyst',
  'Document Processors',
  'Titling',
  'Development Specialist',
  'Controllers',
] as const;
export type AdminDocDepartment = (typeof ADMIN_DOC_DEPARTMENTS)[number];

export interface AdminDocFile {
  fileName: string;
  fileUrl: string;
  label?: string;
  /** Full name of user who uploaded the file */
  uploadedBy?: string;
  /** Cognito user sub (stable user id) of the uploader */
  uploadedBySub?: string;
  /** Timestamp (ms) when the file was uploaded */
  uploadedAt?: number;
  /** When true the file appears on the Onboarding page for team access. */
  isPublic?: boolean;
  /** CloudFront URL — always set since all files upload directly to public/. */
  publicUrl?: string;
}

export interface AdminDoc {
  id: string;
  name: string;
  division: AdminDocDivision;
  department: AdminDocDepartment;
  status: AdminDocStatus;
  description: string;
  documents: AdminDocFile[];
  createdAt: number;
  updatedAt?: number;
  order?: number;
}
